import { render, staticRenderFns } from "./ClientsClientSelect.vue?vue&type=template&id=462a2d07&scoped=true&"
import script from "./ClientsClientSelect.vue?vue&type=script&lang=ts&"
export * from "./ClientsClientSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462a2d07",
  null
  
)

export default component.exports